import React, { Component } from 'react'
import { connect } from 'react-redux'

const referralProgramContainer = (ComposedComponent) => {
    class ReferralProgramContainer extends Component {
        render() {
            return (
                <ComposedComponent {...this.props} />
            )
        }
    }
    const mapStateToProps = ({
        langs: { indexLang },
    }) => ({
        indexLang,
    })
    return connect(mapStateToProps)(ReferralProgramContainer)
}

export default referralProgramContainer
